// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2qKJN","right":"styles_right__2BFHx"};